import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import Panel from './MenuPanel';

const HeaderMenuButtomExpandedMenu = ({
    menus,
    hoverMenuId,
    onClick,
    onMouseLeave,
    onFocus,
    onBlur,
}) => {
    return (
        <Row key="header-bottom-menu-expanded-row" id="header-bottom-menu-expanded-row">
            <Col>
                <Container>
                    <Row>
                        {
                            menus.map((menu, idx) => (
                                <Panel
                                    key={menu.id}
                                    id={menu.id}
                                    menu={menu}
                                    hoverMenuId={hoverMenuId}
                                    menuTabIndex={1000 + idx}
                                    onClick={onClick}
                                    onMouseLeave={onMouseLeave}
                                    onFocus={onFocus}
                                    onBlur={onBlur}
                                />
                            ))
                        }
                    </Row>
                </Container>
            </Col>
        </Row>
    );
};

HeaderMenuButtomExpandedMenu.propTypes = {
    menus: PropTypes.arrayOf(PropTypes.object).isRequired,
    hoverMenuId: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    onMouseLeave: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
};

export default HeaderMenuButtomExpandedMenu;
